import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookType } from "../../types/booksType";

type transactionDetailsState = {
  books: Array<BookType>;
  selectedTransaction?: BookType;
};

const initialBooksState: BookType = {
  id: 0,
  investmentRate: 0,
  loanRate: 0,
  managementFee: 0,
  description: "",
  month: 0,
  year: 0,
};

const initialState: transactionDetailsState = {
  books: [],
  selectedTransaction: initialBooksState,
};

export const booksSlice = createSlice({
  name: "booksState",
  initialState,
  reducers: {
    setBooksState: (state, action: PayloadAction<BookType[]>) => {
      state.books = action.payload;
    },
    setSelectedTransaction: (state, action: PayloadAction<BookType>) => {
      state.selectedTransaction = action.payload;
    },
    resetSelectedTransaction: (state) => {
      state.selectedTransaction = initialBooksState;
    },
    onCloseBook: (state, action: PayloadAction<BookType>) => {
      state.books = [{ ...action.payload }, ...state.books];
    },
    deleteBookTransaction: (state, action: PayloadAction<number>) => {
      state.books = state.books.filter((book) => book.id !== action.payload);
    },
  },
});

export const {
  setBooksState,
  setSelectedTransaction,
  resetSelectedTransaction,
  onCloseBook,
  deleteBookTransaction,
} = booksSlice.actions;

export default booksSlice.reducer;
